
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/coaches/[slug]",
      function () {
        return require("private-next-pages/coaches/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/coaches/[slug]"])
      });
    }
  